import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpPhotographersSsoLogout} from '@features/user/http/user.http.ts'
import {toast} from '@utilities/toast'
import {useAuthStore} from '../store/store'
import {QUERY_KEYS} from '@/queryClient'
import {useTranslation} from 'react-i18next'

export const usePhotographersSsoLogout = (options?: Omit<UseMutationOptions<unknown>, 'queryKey' | 'queryFn'>) => {
    const resetAirbnbTokens = useAuthStore(store => store.resetAirbnbTokens)
    const queryClient = useQueryClient()
    const {t} = useTranslation()
    return useMutation({
        ...options,
        mutationFn: httpPhotographersSsoLogout,
        onError: (error, variables, context) => {
            options?.onError?.(error, variables, context)
            toast.error(t('link_airbnb_account:logout_account_error'))
        },
        onSuccess: (data, variables, context) => {
            resetAirbnbTokens()
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
